import React, { useEffect, useState, useRef } from "react";
import useHttp from "../../../hooks/use-http";
import numberToWords from "number-to-words";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import SimpleMap from "../../../components/gmaps";

const CommercialInvoiceForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);

  const addressRef = useRef({});
  const [addressDetails, setAddressDetails] = useState([]);
  const [addressClose, setAddressClose] = useState(false);

  const bankRef = useRef({});
  const [bankClose, setBankClose] = useState(false);
  const [bankDetails, setBankDetails] = useState([]);

  const refNumberRef = useRef({});
  const [rnClose, setRnClose] = useState(false);
  const [rnDetails, setRnDetails] = useState([]);
  const [customerlist, setcustomerlist] = useState([]);
  const [customerId, setcustomerId] = useState([]);
  const [profarmaInvoiceId, setprofarmaInvoiceId] = useState();
  const [proformaInvoiceList, setproformaInvoiceList] = useState([]);
  const [dndId, setdndId] = useState();

  const currentDate = new Date().toISOString().slice(0, 10);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const {
   
    sendRequest: getcustomer,
  } = useHttp();

  useEffect(() => {
    getcustomer(
      {
        url: `/api/customer/?orgId=${localStorage.getItem("orgId")}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("customer", data[0].name);
        setcustomerlist(data);
      }
    );
  }, [getcustomer]);

  const {
    
    sendRequest: getProformaInvoiceData,
  } = useHttp();

  const loadProformaInvoiceData = (id) => {
    setcustomerId(id);
    getProformaInvoiceData(
      {
        url: `/api/profarmaInvoice/?customerId=${id}`,
      },
      (res) => {
        //console.log("loadProformaInvoiceData", res);
        setproformaInvoiceList(res);
      }
    );
  };

  const {
   
    sendRequest: getProformaInvoiceProductData,
  } = useHttp();

  const loadProformaInvoiceProductData = (id) => {
    var item = proformaInvoiceList.filter(
      (item) => item.profarmaInvoiceId == id
    );

    getProformaInvoiceProductData(
      {
        url: `/api/DeliveryNDispatchForEximDoc/?salesOrderId=${
          item[0].salesOrderId
        }&orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        //console.log(
        //   "deliveryNDispatch",
        //   res.DeliveryDispatch[0].dndProductDetails
        // );
        setProductDetails(res.DeliveryDispatch[0].dndProductDetails);

        frmRef.current.currency.value = res.DeliveryDispatch[0].currencyCode;
        setdndId(res.DeliveryDispatch[0].dndId);

        var i = 0;
        do {
          res.DeliveryDispatch[0].dndProductDetails[i]["measurements"] = "";
          res.DeliveryDispatch[0].dndProductDetails[i]["MarksNumber"] = "";
          res.DeliveryDispatch[0].dndProductDetails[i]["KindNoOfPackages"] = "";

          i++;
        } while (res.DeliveryDispatch[0].dndProductDetails.length > i);

        //console.log(
        //   "deliveryNDispatch afetr",
        //   res.DeliveryDispatch[0].dndProductDetails
        // );
      }
    );
  };

  const {
   
    sendRequest: postCommercialInvoice,
  } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      commercialInvoicedate: moment(frmRef.current.date.value).format(
        "DD/MM/YYYY"
      ),
      customerId: customerId,
      profarmaInvoiceId: profarmaInvoiceId,
      dndId: dndId,
      billOfLoading: frmRef.current.bill_of_lading.value,
      buyerDetails: addressDetails,
      referenceNo: "rnDetails",
      methodOfDispatch: frmRef.current.method_of_dispatch.value,
      typeOfShipment: frmRef.current.type_of_shipment.value,
      countryOfOriginOfGoods: frmRef.current.country_origin.value,
      countryOfFinalDestination: frmRef.current.country_final_destination.value,
      vesselAircraftName: frmRef.current.vessel_name.value,
      voyageNo: frmRef.current.voyage_number.value,
      portOfLoading: frmRef.current.port_of_loading.value,
      dateOfDeparture: moment(frmRef.current.departure_date.value).format(
        "DD/MM/YYYY"
      ),
      portOfDischarge: frmRef.current.port_discharge.value,
      finalDestination: frmRef.current.final_destination.value,
      insuranceCoverPolicyNo: frmRef.current.insurance_policy_number.value,
      letterOfCreditNo: frmRef.current.letter_credit_no.value,
      termsOfPayment: frmRef.current.method_of_payment.value,
      productDetails: productDetails,
      incoTerms2020: frmRef.current.incoterms.value,
      bankDetails: bankDetails,
      consignmentTotal: frmRef.current.total_cost_value.value,
      // country: frmRef.current.country.value,
      accountChargable: frmRef.current.amt_chargeable.value,
      nameOfAuthorizedSignatory:
        frmRef.current.name_of_authorized_signatory.value,
      placeOfIssue: frmRef.current.place_of_issue.value,
      remark: frmRef.current.remark.value,
      createdBy: parseInt(localStorage.getItem("id")),
    };
    //console.log(data);
    if (props.update) {
      data["ciId"] = props.update.ciId;
    }
    postCommercialInvoice(
      {
        url: "/api/commercialInvoice/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Commercial Invoice ${props.update ? "Updated" : "Added"}`
        );
        props.addForm(false);
      }
    );
  };
  useEffect(() => {
    //console.log(props.update);
    if (props.update) {
      frmRef.current.date.value = moment(props.update.date).format(
        "YYYY-MM-DD"
      );
      frmRef.current.customer_name.value = props.update.customerName;
      frmRef.current.customer_id.value = props.update.customerId;
      frmRef.current.bill_of_lading.value = props.update.billOfLoading;
      setAddressDetails(props.update.buyerDetails);
      frmRef.current.reference_numbers = props.update.referenceNo;
      frmRef.current.method_of_dispatch.value = props.update.methodOfDispatch;
      frmRef.current.type_of_shipment.value = props.update.typeOfShipment;
      frmRef.current.country_origin.value = props.update.countryOfOriginGoods;
      frmRef.current.country_final_destination.value =
        props.update.countryOfFinalDestinatn;
      frmRef.current.vessel_name.value = props.update.vesselAircreftName;
      frmRef.current.voyage_number.value = props.update.voyageNo;

      frmRef.current.port_of_loading.value = props.update.portOfLoading;
      frmRef.current.departure_date.value = moment(
        props.update.dateOfDeparture
      ).format("YYYY-MM-DD");
      frmRef.current.port_discharge.value = props.update.portOfDischarge;
      frmRef.current.final_destination.value = props.update.finalDestination;
      frmRef.current.insurance_policy_number.value =
        props.update.insuranceCoverPolicyNo;
      frmRef.current.incoterms.value = props.update.incoTerms2020;
      frmRef.current.letter_credit_no.value = props.update.letterOfCreditNo;
      frmRef.current.method_of_payment.value = props.update.termsOfPayment;
      setProductDetails(props.update.productDetails);
      setBankDetails(props.update.bankDetails);
      frmRef.current.total_cost_value.value = props.update.consignmentTotal;
      frmRef.current.amt_chargeable.value = props.update.accountChargable;
      frmRef.current.name_of_authorized_signatory.value =
        props.update.nameOfAuthorizedSignatory;
      frmRef.current.place_of_issue.value = props.update.placeOfIssue;
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);
  const submitAddress = (e) => {
    e.preventDefault();
    setAddressDetails((x) => [
      ...x,
      {
        srno:
          addressDetails.length > 0
            ? addressDetails[addressDetails.length - 1].srno + 1
            : 1,
        partyType: addressRef.current.party_type.value,
        name: addressRef.current.name.value,
        email: addressRef.current.email.value,
        contactNumber: addressRef.current.contact_number.value,
        contactPersonName: addressRef.current.contact_person_name.value,
        landmark: addressRef.current.landmark.value,
        city: addressRef.current.city.value,
        state: addressRef.current.state.value,
        zipcode: addressRef.current.zipcode.value,
        country: addressRef.current.country.value,
       
      },
    ]);
    //console.log(addressDetails);
  };
  const handleAddressDelete = (index, e) => {
    setAddressDetails(addressDetails.filter((v, i) => i !== index));
  };
  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,

        itemDescription: productRef.current.itemDescription.value,
        hsCode: productRef.current.hs_code.value,

        itemType: productRef.current.itemType.value,
        itemCategory: productRef.current.itemCategory.value,
        itemQuantity: productRef.current.itemQuantity.value,
        rate: productRef.current.rate.value,
        currency: productRef.current.currency.value,
        subTotalAmount: productRef.current.subTotalAmount.value,
        discount: productRef.current.discount.value,
        discountAmount: productRef.current.discountAmount.value,
        totalAmount: productRef.current.totalAmount.value,
        unit: productRef.current.unit.value,
      },
    ]);

    //console.log(productDetails);
  };

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };
  // bank details
  const submitBankDetails = (e) => {
    e.preventDefault();
    setBankDetails((x) => [
      ...x,
      {
        srno:
          bankDetails.length > 0
            ? bankDetails[bankDetails.length - 1].srno + 1
            : 1,

        accountNumber: bankRef.current.account_number.value,
        accountHolderName: bankRef.current.acc_holder_name.value,
        ifscCode: bankRef.current.ifsc_code.value,
      },
    ]);

    //console.log(bankDetails);
  };
  const handleDeleteBank = (index, e) => {
    setBankDetails(bankDetails.filter((v, i) => i !== index));
  };
  const submitRefNum = (e) => {
    e.preventDefault();
    setRnDetails([
      {
        shipperReferenceNumber: refNumberRef.current.shipp_ref_number.value,
        buyerReferenceNumber: refNumberRef.current.buy_ref_number.value,
        isSave: true,
      },
    ]);

    //console.log(rnDetails);
    setRnClose(false);
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "800px",
      maxHeight: "auto",
      height: "400px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const modalStyles2 = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "300px",
      maxHeight: "auto",
      height: "450px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Commercial Invoice Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_name"}>{"Customer Name"}</label>
                      <select
                        id="customer_name"
                        className="form-control"
                        ref={(el) => (frmRef.current["customer_name"] = el)}
                        value={customerId}
                        onChange={(e) => {
                          loadProformaInvoiceData(e.target.value);
                        }}
                      >
                        <option>Select</option>
                        {customerlist &&
                          customerlist.map((x) => (
                            <option
                              key={x.customerId}
                              Customer-id={x.customerId}
                              value={x.customerId}
                            >
                              {x.name + "(" + x.customerCode + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"profarmaInvoiceId"}>
                        {"Proforma Invoice No"}
                      </label>

                      <select
                        id="profarmaInvoiceId"
                        className="form-control"
                        ref={(el) => (frmRef.current["profarmaInvoiceId"] = el)}
                        value={profarmaInvoiceId}
                        onChange={(e) => {
                          setprofarmaInvoiceId(e.target.value);
                          loadProformaInvoiceProductData(e.target.value);
                        }}
                      >
                        <option value="0">Select</option>
                        {proformaInvoiceList &&
                          proformaInvoiceList.map((x) => (
                            <option
                              key={x.profarmaInvoiceId}
                              profarmaInvoice-id={x.profarmaInvoiceId}
                              value={x.profarmaInvoiceId}
                            >
                              {x.profarmaInvoiceNo}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"bill_of_lading"}>
                        {"Bill of Lading/Airway Bill No"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_of_lading"}
                        required
                        ref={(el) => (frmRef.current["bill_of_lading"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    {" "}
                    <div className="col-md-3">
                      <label htmlFor={"buyer_details"}>
                        {"Buyer Details(if not Consignee) "}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        className="btn btn-sm btn-info"
                        onClick={(e) => {
                          e.preventDefault(false);
                          addressDetails &&
                            setAddressDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setAddressClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"reference_numbers"}>
                        {"Reference Numbers"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        className="btn btn-sm btn-warning"
                        onClick={(e) => {
                          e.preventDefault(false);
                          setRnClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"method_of_dispatch"}>
                        {"Method  of Dispatch"}
                      </label>
                      <select
                        id="method_of_dispatch"
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["method_of_dispatch"] = el)
                        }
                      >
                        <option value="">Select</option>
                        <option value="Land">Land</option>
                        <option value="Sea">Sea</option>
                        <option value="Air">Air</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"type_of_shipment"}>
                        {"Type of Shipment"}
                      </label>
                      <select
                        id="type_of_shipment"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["type_of_shipment"] = el)}
                      >
                        <option value="">Select</option>
                        <option value="Full Container Load(FCL)">
                          Full Container Load(FCL)
                        </option>
                        <option value="Less than Container Load(LCL)">
                          Less than Container Load(LCL)
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"country_origin"}>
                        {"Country of Origin of Goods"}
                      </label>
                      <input
                        type={"text"}
                        id={"country_origin"}
                        required
                        ref={(el) => (frmRef.current["country_origin"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"country_final_destination"}>
                        {"Country of Final Destination"}
                      </label>
                      <input
                        type={"text"}
                        id={"country_final_destination"}
                        required
                        ref={(el) =>
                          (frmRef.current["country_final_destination"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"vessel_name"}>
                        {"Vessel/Aircraft Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"vessel_name"}
                        required
                        ref={(el) => (frmRef.current["vessel_name"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"voyage_number"}>
                        {" "}
                        {"Voyage Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"voyage_number"}
                        required
                        ref={(el) => (frmRef.current["voyage_number"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"port_of_loading"}>
                        {"Port of Loading"}
                      </label>
                      <input
                        type={"text"}
                        id={"port_of_loading"}
                        required
                        ref={(el) => (frmRef.current["port_of_loading"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"departure_date"}>
                        {"Date of Departure"}
                      </label>
                      <input
                        type={"date"}
                        id={"departure_date"}
                        required
                        ref={(el) => (frmRef.current["departure_date"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"port_discharge"}>
                        {" "}
                        {"Port of Discharge"}
                      </label>
                      <input
                        type={"text"}
                        id={"port_discharge"}
                        required
                        ref={(el) => (frmRef.current["port_discharge"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"final_destination"}>
                        {" "}
                        {"Final Destination"}
                      </label>
                      <input
                        type={"text"}
                        id={"final_destination"}
                        required
                        ref={(el) => (frmRef.current["final_destination"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"insurance_policy_number"}>
                        {"Insurance Cover Policy Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"insurance_policy_number"}
                        required
                        ref={(el) =>
                          (frmRef.current["insurance_policy_number"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"letter_credit_no"}>
                        {" "}
                        {"Letter Of Credit No."}
                      </label>
                      <input
                        type={"text"}
                        id={"letter_credit_no"}
                        required
                        ref={(el) => (frmRef.current["letter_credit_no"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"method_of _payment"}>
                        {"Terms/Method of payment"}
                      </label>
                      <input
                        type={"text"}
                        id={"method_of _payment"}
                        required
                        ref={(el) => (frmRef.current["method_of_payment"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        className="btn btn-sm btn-success"
                        onClick={() => {
                          //  productDetails && setProductDetails((items) => items.filter((x) => x.isSave));
                          setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"incoterms"}>{"Incoterms® 2020"}</label>
                      <input
                        type={"text"}
                        id={"incoterms"}
                        required
                        ref={(el) => (frmRef.current["incoterms"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"taxAmount"}>{"Tax Amount "}</label>
                      <input
                        type={"text"}
                        id={"taxAmount"}
                        required
                        ref={(el) => (frmRef.current["taxAmount"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_cost_value"}>
                        {"Consignment Total/Total Cost"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost_value"}
                        required
                        ref={(el) => (frmRef.current["total_cost_value"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"currency"}>{"Currency"}</label>
                      <input
                        type={"text"}
                        id={"currency"}
                        readOnly
                        required
                        ref={(el) => (frmRef.current["currency"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {"Amount Chargeable"}
                      </label>
                      <input
                        type={"text"}
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"bank_details"}>{"Bank Details"}</label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type={"button"}
                        className="btn btn-sm btn-secondary"
                        onClick={() => {
                          bankDetails &&
                            setBankDetails((items) =>
                              items.filter((x) => x.isSave)
                            );
                          setBankClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"name_of_authorized_signatory"}>
                        {"Name of Authorized Signatory"}
                      </label>
                      <input
                        type={"text"}
                        id={"name_of_authorized_signatory"}
                        required
                        ref={(el) =>
                          (frmRef.current["name_of_authorized_signatory"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"place_of_issue"}>
                        {"Place of Issue"}
                      </label>
                      <input
                        type={"text"}
                        id={"place_of_issue"}
                        required
                        ref={(el) => (frmRef.current["place_of_issue"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>

      {/* address modal */}
      {addressClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">
              {" "}
              Forwarding Agent/Notify Party Details
            </h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setAddressClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"party_type"}>{"Party Type"}</label>
              <select
                className="form-control"
                ref={(el) => (addressRef.current["party_type"] = el)}
                autoComplete="off"
              >
                <option>Forwarding Agent</option>
                <option>Notify Party</option>
                <option>Additional Notify Party</option>
              </select>
            </div>
            <div className="col-md-3">
              <label htmlFor={"name"}>Name</label>
              <input
                type={"input"}
                id={"name"}
                required
                ref={(el) => (addressRef.current["name"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"email"}>Email id</label>
              <input
                type={"input"}
                id={"email"}
                required
                ref={(el) => (addressRef.current["email"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"contact_person_name"}>contact Person Name</label>
              <input
                type={"input"}
                id={"contact_person_name"}
                required
                ref={(el) => (addressRef.current["contact_person_name"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"contact_number"}>Contact Number</label>
              <input
                type={"input"}
                id={"contact_number"}
                required
                ref={(el) => (addressRef.current["contact_number"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"landmark"}>Address(landmark)</label>
              <input
                type={"input"}
                id={"landmark"}
                required
                ref={(el) => (addressRef.current["landmark"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"city"}>City</label>
              <input
                type={"input"}
                id={"city"}
                required
                ref={(el) => (addressRef.current["city"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"state"}>State</label>
              <input
                type={"input"}
                id={"state"}
                required
                ref={(el) => (addressRef.current["state"] = el)}
                className="form-control"
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-3">
              <label htmlFor={"zipcode"}>Zip Code</label>
              <input
                type={"text"}
                id={"zipcode"}
                required
                ref={(el) => (addressRef.current["zipcode"] = el)}
                className="form-control"
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"country"}>Country</label>
              <input
                type={"text"}
                id={"country"}
                required
                ref={(el) => (addressRef.current["country"] = el)}
                className="form-control"
              />
            </div>
            <div className="col-md-3">
              <br />
              <button
                className="btn-sm btn btn-secondary"
                onClick={submitAddress}
              >
                +
              </button>
            </div>
          </div>

          <hr />

          <table className="table table-sm table-bordered table-responsive ">
            {" "}
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Party Type</th>
                <th>Name</th>
                <th>Email</th>
                <th>contact Person Name</th>
                <th>Contact Number</th>
                <th>Address(landmark)</th>
                <th>City</th>
                <th>State/Province/region</th>
                <th>Zip Code</th>
                <th>Country</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {addressDetails &&
                addressDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.srno}</td>
                      <td>{itm.partyType}</td>
                      <td>{itm.name}</td>
                      <td>{itm.email}</td>
                      <td>{itm.contactPersonName}</td>
                      <td>{itm.contactNumber}</td>
                      <td>{itm.landmark}</td>
                      <td>{itm.city}</td>
                      <td>{itm.state}</td>
                      <td>{itm.zipcode}</td>
                      <td>{itm.country}</td>

                      <td>
                        {" "}
                        <button
                          className="btn"
                          onClick={(e) => handleAddressDelete(i, e)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                addressDetails.map((x) => (x["isSave"] = true));
                setAddressClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/* end address modal */}
      {/*reference_numbers modal */}
      {rnClose && (
        <Modal isOpen={true} style={modalStyles2}>
          <div className="">
            <div className="">
              <h3 className="card-title">Reference Numbers Details</h3>
              <div className="card-tools text-right">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="remove"
                  onClick={() => setRnClose(false)}
                >
                  <i className="fas fa-times" />
                </button>
                <hr />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-12">
                <label htmlFor={"shipp_ref_number"}>
                  Shipper Reference No{" "}
                </label>
                <input
                  type={"input"}
                  id={"shipp_ref_number"}
                  required
                  ref={(el) => (refNumberRef.current["shipp_ref_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-12">
                <label htmlFor={"buy_ref_number"}>Buyer Reference No</label>
                <input
                  type={"input"}
                  id={"buy_ref_number"}
                  required
                  ref={(el) => (refNumberRef.current["buy_ref_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-12">
                <label htmlFor={"expo_dec_number"}>Export Declaration No</label>
                <input
                  type={"input"}
                  id={"expo_dec_number"}
                  required
                  ref={(el) => (refNumberRef.current["expo_dec_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>

            <div className="text-center">
              <button className="btn btn-sm btn-primary" onClick={submitRefNum}>
                Save
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* bank modal start */}
      {bankClose && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title"> Bank Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setBankClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"account_number"}>Account Number</label>

                <input
                  type={"input"}
                  id={"account_number"}
                  required
                  ref={(el) => (bankRef.current["account_number"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"acc_holder_name"}>Acc Holder Name</label>

                <input
                  type={"input"}
                  id={"acc_holder_name"}
                  required
                  ref={(el) => (bankRef.current["acc_holder_name"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label htmlFor={"ifsc_code"}>IFSC Code</label>

                <input
                  type={"input"}
                  id={"ifsc_code"}
                  required
                  ref={(el) => (bankRef.current["ifsc_code"] = el)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-3">
              <br />
              <div className="form-group">
                <button
                  className="btn btn-sm btn-secondary"
                  onClick={submitBankDetails}
                  type="button"
                >
                  +
                </button>
              </div>
            </div>
          </div>

          <hr />
          <div className="flexRow">
            <table className="table table-bordered text-center table-sm">
              <thead>
                <tr className="">
                  <th>Sr. No</th>
                  <th>Account Number</th>
                  <th>Account Holder Name</th>
                  <th>IFSC Code</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {bankDetails &&
                  bankDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.accountNumber}</td>
                        <td>{itm.accountHolderName}</td>
                        <td>{itm.ifscCode}</td>

                        <td>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(e) => handleDeleteBank(i, e)}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          <div className="text-center">
            <button
              type="submit"
              className="btn btn-sm btn-primary"
              onClick={() => {
                bankDetails && bankDetails.map((x) => (x["isSave"] = true));
                setBankClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
      {/* bank modal end */}

      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title"> Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <hr />

          <table className="table table-sm table-bordered">
            {" "}
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Item Id</th>
                <th>Item Description</th>
                <th>Item Type</th>
                <th>Item Category/Variety</th>
                <th>Rate</th>
                <th>Item Quantity</th>
                <th>Unit</th>
                <th>Amount</th>
                <th>Discount</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {productDetails &&
                productDetails.map((itm, i) => {
                  return (
                    <tr key={i}>
                      <td>{itm.linesrno}</td>
                      <td>{itm.itemId}</td>
                      <td>{itm.productName}</td>
                      <td>{itm.cropName}</td>
                      <td>{itm.varietyName}</td>
                      <td>{itm.rate}</td>
                      <td>{itm.deliveryDispatchQuantity}</td>
                      <td>{itm.unitAbbreviation}</td>
                      <td>{itm.subTotalAmount}</td>
                      <td>{itm.discount}</td>
                      <td>{itm.totalLineAmount}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Modal>
      )}
    </>
  );
};

export default CommercialInvoiceForm;
